/* eslint-disable radix */
import { TableCell, TableRow } from '@material-ui/core';
import moment from 'moment';
import React from 'react';
import { formatIV } from '../../../../utils/numberFormatFunc';

const OITableCells = ({ styles2, row }) => {
  const formatComma = (trade) => {
    return trade ? trade.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '0';
  };
  return (
    <TableRow style={{ height: '5px' }} key={row.time}>
      <TableCell
        style={{
          ...styles2.modalTableRow,
          width: '85px',
          padding: 0,
        }}
        align="center"
      >
        {moment(row.date).format('DD-MMM-YY')}
      </TableCell>
      <TableCell
        style={{
          ...styles2.modalTableRow,
          textAlign: 'end',
          backgroundColor: '#c3daf0',
          width: 50,
          padding: '0 5px',
        }}
        align="center"
      >
        {
          formatComma(
            row.contracts
          ) /* {moment(row.date).format("DD-MMM-YY")}   {row.oichg} */
        }
      </TableCell>
      <TableCell
        style={{
          ...styles2.modalTableRow,
          textAlign: 'end',
          padding: '0 5px',
          width: '42px',
        }}
        align="center"
      >
        {row.oichg >= 0 ? (
          <span style={{ color: 'green' }}>{formatComma(row.oichg)}</span>
        ) : (
          <span style={{ color: 'red' }}>{formatComma(row.oichg)}</span>
        )}
      </TableCell>

      <TableCell
        style={{
          ...styles2.modalTableRowGray,
          backgroundColor: '#cee3c0',
          padding: '0 5px',
          textAlign: 'end',
        }}
        align="right"
      >
        {formatComma(row.volume)}{' '}
      </TableCell>

      <TableCell
        style={{
          ...styles2.modalTableRow,
          backgroundColor: 'transparent',
          textAlign: 'end',
          padding: '0 5px',
          width: '32px',
        }}
        align="right"
        width={32}
      >
        {!row.bid
          ? '-'
          : row.bid > 0
          ? parseInt((row.bid / row.volume) * 100) + `%`
          : row.bid * 100 + `%`}
      </TableCell>
      {/* )} */}
      <TableCell
        style={{
          ...styles2.modalTableRow,
          width: '32px',
          textAlign: 'end',
          padding: '0px 5px',
        }}
        align="center"
        width={32}
      >
        {!row.ask
          ? '-'
          : row.ask > 0
          ? parseInt((row.ask / row.volume) * 100) + `%`
          : row.ask * 100 + `%`}{' '}
      </TableCell>

      <TableCell
        style={{
          ...styles2.modalTableRowYellow,
          backgroundColor: 'transparent',
          textAlign: 'end',
          padding: '0 5px',
        }}
        align="center"
      >
        {parseInt(row.itemProb * 100)}%
      </TableCell>
      <TableCell
        style={{
          ...styles2.modalTableRow,

          width: '80px',
          backgroundColor: 'rgb(211, 211, 211)',
          textAlign: 'end',
          padding: '0 5px',
        }}
        align="center"
      >
        ${row.close > 0 ? row.close.toFixed(2) : 0}
      </TableCell>
      <TableCell
        style={{
          ...styles2.modalTableRow,
          width: '80px',
          textAlign: 'end',
          padding: '0 2px',
        }}
        align="center"
      >
        {formatIV(row.ivol)}
      </TableCell>
      <TableCell
        style={{
          ...styles2.modalTableRow,
          width: '30px',
          textAlign: 'end',
          padding: '0 5px',
        }}
        align="center"
      >
        {row.ivolchg >= 0 ? (
          <span style={{ color: 'green' }}>
            {(row.ivolchg * 100).toFixed(1)}%
          </span>
        ) : (
          <span style={{ color: 'red' }}>
            {(row.ivolchg * 100).toFixed(1)}%
          </span>
        )}
      </TableCell>

      <TableCell
        style={{
          ...styles2.modalTableRow,
          width: '30px',
          backgroundColor: '#fbf3a8',
          textAlign: 'end',
          padding: '0 5px',
        }}
        align="center"
      >
        {!row.RR ? '-' : row.RR.toFixed(2)}
      </TableCell>
    </TableRow>
  );
};
export default OITableCells;



// WEBPACK FOOTER //
// ./src/components/Modals/OI Modal/components/OITableCells.jsx